import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="py-12 px-4 bg-stone-900 text-stone-400 text-center" data-id="element-1">
        <div className="max-w-6xl mx-auto" data-id="element-2">
          <p className="font-medium text-stone-200 mb-4" data-id="element-3">USA Sin Caos</p>
          <p className="text-sm mb-4" data-id="element-4">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-6 text-sm" data-id="element-5">
            <button onClick={() => setPrivacyOpen(true)} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-6">
              Política de Privacidad
            </button>
            <span className="text-stone-600" data-id="element-7">•</span>
            <button onClick={() => setTermsOpen(true)} className="hover:text-white transition-colors underline-offset-4 hover:underline" data-id="element-8">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-9">
        <div className="prose prose-stone max-w-none" data-id="element-10">
          <p className="text-stone-600 mb-4" data-id="element-11">
            <strong data-id="element-12">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-13">
            1. Información que Recopilamos
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-14">
            Recopilamos información que nos proporcionas directamente cuando
            realizas una compra, incluyendo tu nombre y dirección de correo
            electrónico. Esta información es necesaria para procesar tu pedido y
            enviarte el producto digital.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-15">
            2. Uso de la Información
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-16">
            Utilizamos tu información personal para:
          </p>
          <ul className="list-disc pl-6 text-stone-600 mb-4 space-y-2" data-id="element-17">
            <li data-id="element-18">Procesar y entregar tu compra</li>
            <li data-id="element-19">Enviarte actualizaciones sobre tu pedido</li>
            <li data-id="element-20">Responder a tus preguntas o solicitudes</li>
            <li data-id="element-21">Mejorar nuestros productos y servicios</li>
          </ul>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-22">
            3. Protección de Datos
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-23">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tu información personal contra acceso no autorizado,
            pérdida o alteración.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-24">
            4. Compartir Información
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-25">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros, excepto cuando sea necesario para procesar tu pago a
            través de procesadores de pago seguros.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-26">
            5. Tus Derechos
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-27">
            Tienes derecho a acceder, corregir o eliminar tu información
            personal. También puedes solicitar una copia de los datos que
            tenemos sobre ti.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-28">
            6. Cookies
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-29">
            Utilizamos cookies esenciales para el funcionamiento del sitio web.
            No utilizamos cookies de seguimiento ni publicidad.
          </p>
        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-30">
        <div className="prose prose-stone max-w-none" data-id="element-31">
          <p className="text-stone-600 mb-4" data-id="element-32">
            <strong data-id="element-33">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-34">
            1. Aceptación de los Términos
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-35">
            Al comprar y descargar "USA Sin Caos", aceptas estos términos y
            condiciones en su totalidad. Si no estás de acuerdo con alguna parte
            de estos términos, no debes realizar la compra.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-36">
            2. Producto Digital
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-37">
            "USA Sin Caos" es un producto digital en formato PDF. Una vez
            completada la compra, recibirás acceso inmediato para descargar el
            archivo. Debido a la naturaleza digital del producto, no se aceptan
            devoluciones una vez descargado.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-38">
            3. Licencia de Uso
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-39">
            Al comprar este producto, obtienes una licencia personal e
            intransferible para usar el contenido. No está permitido:
          </p>
          <ul className="list-disc pl-6 text-stone-600 mb-4 space-y-2" data-id="element-40">
            <li data-id="element-41">Redistribuir, vender o compartir el PDF con terceros</li>
            <li data-id="element-42">Modificar el contenido para reventa</li>
            <li data-id="element-43">
              Utilizar el contenido para fines comerciales sin autorización
            </li>
          </ul>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-44">
            4. Propiedad Intelectual
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-45">
            Todo el contenido de "USA Sin Caos", incluyendo texto, gráficos y
            diseño, está protegido por derechos de autor. La compra del producto
            no transfiere ningún derecho de propiedad intelectual.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-46">
            5. Limitación de Responsabilidad
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-47">
            Este producto ofrece información y estrategias de organización
            personal. Los resultados pueden variar según cada persona. No
            garantizamos resultados específicos y no somos responsables de cómo
            apliques la información contenida en el PDF.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-48">
            6. Precio y Pago
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-49">
            El precio actual del producto es de <strong data-id="element-50">$6.97 USD</strong>. El
            pago se procesa de forma segura a través de procesadores de pago
            certificados. Todos los precios están sujetos a cambios sin previo
            aviso.
          </p>

          <h3 className="text-lg font-semibold text-stone-900 mt-6 mb-3" data-id="element-51">
            7. Modificaciones
          </h3>
          <p className="text-stone-600 mb-4" data-id="element-52">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor inmediatamente después
            de su publicación en esta página.
          </p>
        </div>
      </Modal>
    </>;
}